import React from 'react';
import Layout from '../../../../components/Layout';
import FeaturedPayPalSuccess from './FeaturedPayPalSuccess';

const title = 'Pago de Featured - PayPal';

export default {
  path: '/featured/paypal/success',

  async action({ store, query }) {
    // Get orderId from URL (PayPal adds token parameter)
    const orderId = query.token;
    
    // Parse featured data from query string
    let featuredData = {};
    try {
      if (query.data) {
        featuredData = JSON.parse(decodeURIComponent(query.data));
      }
    } catch (e) {
      console.error('Error parsing featured data:', e);
    }

    // Check if user is logged in
    const state = store.getState();
    if (!state.runtime.isAuthenticated) {
      return { redirect: '/login?redirect=/user/boats' };
    }

    return {
      title,
      component: (
        <Layout>
          <FeaturedPayPalSuccess 
            orderId={orderId}
            featuredData={featuredData}
          />
        </Layout>
      ),
    };
  },
};
